module.exports = __webpack_public_path__ + "static/media/contact-slide-5.9f088b6e.jpg";